export default "__VITE_ASSET__7070c12d__"